import { put, takeLatest } from 'redux-saga/effects';
import { GetStatistiche } from '../../reducers/r_index';

import authService from '../../components/api-authorization/AuthorizeService';


// worker saga: makes the api call when triggerAction sees the action
export function* runAction({ payload: { codiceUtente } }) {
    try {
       
        const token = yield authService.getAccessToken();

        const response = yield fetch('/Statistiche/GetStatistiche/' + codiceUtente , {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });

        const requestResult = yield response.json();
        
        var statistiche = requestResult["Statistiche"];       
       
        //ricavo i dati per i vari grafici
        const tipologia = [
            { type: 'Enterprise', val: parseInt(statistiche.Enterprise) },
            { type: 'ERP', val: parseInt(statistiche.ERP) }
        ];

        const generali = [
            { type: 'Attive', val: parseInt(statistiche.Attive) },
            { type: 'In Scadenza', val: parseInt(statistiche.InScadenza) },
            { type: 'Scadute', val: parseInt(statistiche.Scadute) },
            { type: 'Attive Ultimo Mese', val: parseInt(statistiche.AttiveUltimoMese) },
            { type: 'Non Associate', val: parseInt(statistiche.NonAssociate) },
            { type: 'Bloccate', val: parseInt(statistiche.Bloccate) },
        ];

        const anno = [
            { type: 'Attivate Anno1', val: parseInt(statistiche.AttivateAnno1) },
            { type: 'Attivate Anno2', val: parseInt(statistiche.AttivateAnno2) },
            { type: 'Attivate Anno3', val: parseInt(statistiche.AttivateAnno3) }
        ];

        
        yield put(GetStatistiche.creators.getStatisticheSuccess({ tipologia, generali, anno }));

    } catch (e) {
        yield put(GetStatistiche.creators.getStatisticheFailed(e.message)); // failed to fetch data
    }
}

// watcher saga: watches for actions dispatched to the store, starts runAction
export function* triggerAction() {
    yield takeLatest(GetStatistiche.types.GET_STATISTICHE_REQUEST, runAction);
}



/* esempio risposta

 

        */